import { render } from "./Authorize.vue?vue&type=template&id=f5910c7c&scoped=true&ts=true"
import script from "./Authorize.vue?vue&type=script&lang=ts"
export * from "./Authorize.vue?vue&type=script&lang=ts"

import "./Authorize.vue?vue&type=style&index=0&id=f5910c7c&scoped=true&lang=css"

import exportComponent from "/Users/georgemayer/Sites/apps/lognote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5910c7c"]])

export default __exports__